import Inputmask from 'inputmask/dist/inputmask/inputmask.date.extensions';

const
  SEMICOLON = encodeURIComponent(';'),
  BRACKETS  = encodeURIComponent('[]'),
  DASH      = '-'
;

class FilterView {
  constructor(container$) {
    this.container$  = container$;
    this.region$     = container$.find('select[data-voc-krammer-filter-region]');
    this.section$    = container$.find('select[data-voc-krammer-filter-section]');
    this.subsection$ = container$.find('select[data-voc-krammer-filter-subsection]');
    this.author$     = container$.find('select[data-voc-krammer-filter-author]');
    this.startDate$  = container$.find('input[data-voc-krammer-filter-date-start]');
    this.endDate$    = container$.find('input[data-voc-krammer-filter-date-end]');
    this.submit$     = container$.find('input[data-voc-krammer-filter-submit]');

    Inputmask('dd-mm-yyyy', {placeholder: 'dd-mm-aaaa'}).mask(this.startDate$);
    Inputmask('dd-mm-yyyy', {placeholder: 'dd-mm-aaaa'}).mask(this.endDate$);

    this.bindEvents();
  }

  bindEvents() {
    this.container$.on('submit', this.buildFormAction.bind(this));
  }

  buildFormAction() {
    var action,
        filterType,
        textValue,
        params,
        url,
        region     = this.region$.val(),
        section    = this.section$.val(),
        subsection = this.subsection$.val(),
        author     = this.author$.val(),
        startDate  = this.startDate$.val().trim(),
        endDate    = this.endDate$.val().trim()
    ;
    if (!(startDate ==='' && endDate ==='')){
        startDate = (startDate ? startDate :'01-01-2006');
        endDate = (endDate ? endDate :this.getToday());
    }

    region     = region ? `&edition_filter${BRACKETS}=${region}` : '';
    section    = section ? `&section${BRACKETS}=${section}` : '';
    subsection = subsection ? `&subsection${BRACKETS}=${subsection}` : '';
    author     = author ? `&author${BRACKETS}=${author}` : '';

    filterType = this.container$.data('voc-krammer-filter');
    action  = this.container$.attr('action') || '';

    if (filterType === 'date') {
      startDate = startDate ? `${startDate.split('-').reverse().join('')}` : '';
      endDate   = endDate ? `${DASH}${endDate.split('-').reverse().join('')}` : '';
      params    = `${startDate}${endDate}.html?filter=true${region}${section}${subsection}${author}`;
    } else {
      textValue = this.container$.data('voc-krammer-filter-value');
      startDate = startDate ? `&date=${startDate.split('-').reverse().join('')}` : '';
      endDate   = endDate ? `${SEMICOLON}${endDate.split('-').reverse().join('')}` : '';
      params    = `${textValue}?filter=true${region}${section}${subsection}${author}${startDate}${endDate}`;
    }

    url = `${action}${params}`;
    document.location.href = url;

    return false;
  }

  getToday(){
    let today = new Date();
    let day = String(today.getDate()).padStart(2, '0');
    let month = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let year = today.getFullYear();

    return  day + '-' + month + '-' + year;
  }

}

export default FilterView;



// WEBPACK FOOTER //
// ./src/views/filter.js